(function (widgets) {
  const AIChat = widgets.Widget.extend(
    {
      constructor: function AIChatConstructor(object) {
        // For Opt-in view.
        const consent = object['passthru'][`${object.id}-consent_given`];
        object['consent_given'] =
          typeof consent === 'string' ? consent === 'true' : consent; // default (null)

        // If there's a pending message, add class to hide AI response before it renders
        if (sessionStorage.getItem('ai-chat-pending-message')) {
          document.body.classList.add('ai-chat-pending-response');
        }

        AIChat.__super__.constructor.call(this, object);

        if (window.matchMedia('(pointer: coarse)').matches) {
          $('.content-container').css('min-height', 0);
          $('html, body').animate(
            {
              scrollTop: $('header').offset().top,
            },
            0
          );
        }

        $(page_state).on('after_content_loaded', function () {
          // Hide the default navigation
          mainNav.hide();
        });
      },
      render: function () {
        let self = this;
        AIChat.__super__.render.call(this);

        if (this._object.error_message) {
          this.errorContinueBtn = document.getElementById(
            'ai-chat-error-continue'
          );

          this.handleErrorContinue = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            click_next({ key: '', type: 'click' });
          };

          this.errorContinueBtn.addEventListener(
            'click',
            this.handleErrorContinue
          );

          return;
        }

        // Auto advance if "finished" already
        if (this._object.finished) {
          setTimeout(function () {
            click_next({ key: '', type: 'click' });
          }, 8000);
        }
        // Consent view shown (null or false)
        if (
          this._object.consent_given === null ||
          !this._object.consent_given
        ) {
          this.continueBtn = document.getElementById('continue_button');
          this.skipBtn = document.getElementById('skip_button');
          this.consentInput = document.getElementsByName(
            `${this._object.id}-consent_given`
          );
          this.consentAcknowledged = document.getElementById(
            'ai-consent-acknowledged'
          );

          // Event Handlers
          this.handleChange = function (event) {
            const isChecked = event.target.checked;

            if (isChecked) {
              $('.ai-consent-content-acknowledge').addClass('checked');

              // Enable the Continue button
              self.continueBtn.disabled = false;
            } else {
              $('.ai-consent-content-acknowledge').removeClass('checked');

              // Disable the Continue button
              self.continueBtn.disabled = true;
            }
          };
          this.handleContinue = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            // Update hidden fields
            self._setAction('agree');
            if (self.consentInput && self.consentInput.length > 0)
              self.consentInput[0].value = true;

            click_next({ key: '', type: 'click' });
          };
          this.handleSkip = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            // Update hidden fields
            self._setAction('disagree');
            if (self.consentInput && self.consentInput.length > 0)
              self.consentInput[0].value = false;

            click_next({ key: '', type: 'click' });
          };

          // Event Listeners
          this.continueBtn.addEventListener('click', this.handleContinue); // mouse
          this.skipBtn.addEventListener('click', this.handleSkip); // mouse
          this.consentAcknowledged.addEventListener(
            'change',
            this.handleChange
          );

          this.continueBtn.addEventListener('keypress', this.handleContinue); // keyboard (a11y)
          this.skipBtn.addEventListener('keypress', this.handleSkip); // keyboard (a11y)

          return;
        }

        // If consent is given, initialize the rest of the widget.
        if (this._object.consent_given) {
          this.messageReportBtns =
            document.querySelectorAll('svg[data-report]');
          this.userResponse = document.getElementById(
            'r-' + this._object.input_id
          );
          this.submitBtn = document.getElementById('ai-submit');
          this.conversation = document.getElementById('ai-conversation');
          this.statusIndicator = document.querySelector('.ai-status-indicator');
          this.inputContainer = document.querySelector('.ai-chat-input');
          this.inputWrapper = document.querySelector('.ai-chat-input-wrapper');
          this.pendingUserMessage = sessionStorage.getItem(
            'ai-chat-pending-message'
          );

          // Auto-focus on the input when not disabled
          if (!self.userResponse.disabled) self.userResponse.focus();

          // Clear from storage immediately to avoid re-processing
          if (this.pendingUserMessage) {
            sessionStorage.removeItem('ai-chat-pending-message');
          }

          // Save original redirecting HTML from template for reuse
          if (this.statusIndicator && this.statusIndicator.innerHTML.trim()) {
            this.savedRedirectingHTML = this.statusIndicator.innerHTML;
          }

          this.maxCharacters = 500;
          this.defaultButtonText =
            (self.submitBtn &&
              self.submitBtn.querySelector('.button-text') &&
              self.submitBtn.querySelector('.button-text').textContent) ||
            'Send';

          // Helper to reuse mobile events to change layout
          const isSkinny = function () {
            return window.matchMedia('(max-width: 767px)').matches;
          };

          this.setButtonText = function (text) {
            const label =
              self.submitBtn && self.submitBtn.querySelector('.button-text');
            if (label) label.textContent = text;
          };

          this.setLoadingState = function (isLoading) {
            if (!self.submitBtn) return;
            if (isLoading) {
              self.setButtonText(self._object.sending_text);
              $(self.submitBtn).addClass('loading-button');
            } else {
              self.setButtonText(self.defaultButtonText);
              $(self.submitBtn).removeClass('loading-button');
            }
          };

          this.setStatus = function (text, className, visible) {
            if (!self.statusIndicator) return;
            if (typeof text === 'string')
              self.statusIndicator.textContent = text;
            self.statusIndicator.className = className || 'ai-status-indicator';
            self.statusIndicator.style.display = visible ? 'block' : 'none';
          };

          this.disableInput = function (disabled) {
            if (!self.userResponse || !self.submitBtn) return;
            self.userResponse.disabled = !!disabled;
            self.submitBtn.disabled = !!disabled;
            $(self.inputContainer).toggleClass('disabled', !!disabled);
          };

          // This will help to maintain spacing when status indicator is shown (probably dirty solution)
          this.toggleStatusSpacing = function (visible) {
            if (!self.inputWrapper) return;
            self.inputWrapper.classList.toggle(
              'ai-chat-input-wrapper--with-status',
              !!visible
            );
            if (self.conversation) {
              self.conversation.classList.toggle(
                'ai-chat-conversation--with-status',
                !!visible
              );
            }
          };
          // Update input height when adding text
          this.updateInputHeight = function () {
            if (!self.inputWrapper) return;
            const height = self.inputWrapper.offsetHeight;
            document.documentElement.style.setProperty(
              '--input-height',
              height + 'px'
            );
          };
          // Auto-grow textarea
          this.autoGrow = function () {
            if (!self.userResponse) return;

            const skinny = isSkinny();
            const mobileMin = 24; // This refers to one single line height (placeholder height)
            const mobileMax = 200;

            // If empty on mobile, force the visual minimum and bail early
            if (skinny && !self.userResponse.value.length) {
              self.userResponse.style.height = mobileMin + 'px';
              self.userResponse.style.overflowY = 'hidden';
              self.updateInputHeight();
              return;
            }

            // reset to measure
            self.userResponse.style.height = 'auto';
            const contentHeight = self.userResponse.scrollHeight;

            if (skinny) {
              if (contentHeight <= mobileMin) {
                self.userResponse.style.height = mobileMin + 'px';
                self.userResponse.style.overflowY = 'hidden';
              } else if (contentHeight < mobileMax) {
                self.userResponse.style.height = contentHeight + 'px';
                self.userResponse.style.overflowY = 'hidden';
              } else {
                self.userResponse.style.height = mobileMax + 'px';
                self.userResponse.style.overflowY = 'auto';
              }
            } else {
              self.userResponse.style.height = contentHeight + 'px';
              self.userResponse.style.overflowY = 'hidden';
            }

            // Input will be growing as text is added and textarea height changes
            self.updateInputHeight();
          };
          // Scroll to bottom of conversation
          this.scrollToBottom = function () {
            const target =
              self.conversation ||
              document.scrollingElement ||
              document.documentElement;
            const scrollFn = function () {
              if (target) {
                target.scrollTop = target.scrollHeight;
              }
              window.scrollTo(0, document.body.scrollHeight);
            };

            scrollFn();
            window.requestAnimationFrame(scrollFn);
            setTimeout(scrollFn, 50);
          };
          // Observe conversation changes to auto-scroll on new messages
          this.observeConversation = function () {
            if (!self.conversation) return;
            if (self.conversationObserver) {
              self.conversationObserver.disconnect();
            }
            self.conversationObserver = new MutationObserver(function () {
              self.scrollToBottom();
            });
            self.conversationObserver.observe(self.conversation, {
              childList: true,
              subtree: true,
            });
          };

          // Auto-resize textarea to fit written content
          this.autoResizeTextarea = function () {
            self.autoGrow();
          };
          // Character count handler to not surpass 500 characters length
          this.handleCharacterCount = function () {
            const currentLength = self.userResponse.value.length;
            if (currentLength > self.maxCharacters) {
              self.setStatus(
                self._object.max_characters_text,
                'ai-status-indicator ai-status-error',
                true
              );
              self.toggleStatusSpacing(true);
              if (self.conversation) {
                self.conversation.classList.remove(
                  'ai-chat-conversation--typing'
                );
              }
              $(self.userResponse).addClass('input-error');
              $(self.inputContainer).addClass('error');
            } else {
              self.setStatus('', 'ai-status-indicator', false);
              self.toggleStatusSpacing(false);
              if (self.conversation) {
                self.conversation.classList.remove(
                  'ai-chat-conversation--typing'
                );
              }
              $(self.userResponse).removeClass('input-error');
              $(self.inputContainer).removeClass('error');
            }
            self.autoResizeTextarea();
          };
          this.submit = function (event) {
            if (event.type === 'keypress' && event.key !== 'Enter') return;
            if (!self.userResponse || !self.submitBtn || !self.conversation)
              return;

            event.preventDefault();
            event.stopImmediatePropagation();

            const submitState = self.submitBtn.dataset.state;

            if (submitState === 'continue') {
              // Update hidden field based on button state
              self._setAction(submitState);

              self.toggleStatusSpacing(false);

              // We obtain user message to keep it visible while sending
              const userMessage = self.userResponse.value.trim();
              if (!userMessage) return;

              // Lock input and show sending state (no status yet, just Sending button)
              self.disableInput(true);
              self.setLoadingState(true);
              // Store the message in sessionStorage to survive re-render
              sessionStorage.setItem('ai-chat-pending-message', userMessage);

              // Trigger submit (textarea keeps visible text while sending)
              click_next({ key: '', type: 'click' });
              self.scrollToBottom();
            } else if (submitState === 'end') {
              const modal = $(`#end-chat-modal`);
              const modalEl = document.getElementById(`end-chat-modal`);
              const nextBtn = modalEl.querySelector('button.next');

              this.handleNext = function (event) {
                event.preventDefault();

                // Update hidden field based on button state
                self._setAction(submitState);

                // Close the confirmation modal
                modal.modal('hide');

                // Show redirecting message and disable input / button
                // Reuse the original redirecting HTML from template when pressing End chat button
                if (self.savedRedirectingHTML) {
                  self.statusIndicator.innerHTML = self.savedRedirectingHTML;
                }
                self.statusIndicator.style.display = 'block';
                self.statusIndicator.className =
                  'ai-status-indicator ai-status-redirecting';
                self.conversation.classList.add(
                  'ai-chat-conversation--redirecting'
                );
                self.toggleStatusSpacing(true);
                self.disableInput(true);

                setTimeout(function () {
                  click_next({ key: '', type: 'click' });
                }, 2000);
              };

              // Show "End chat" modal
              modal.modal('show');

              nextBtn.addEventListener('click', this.handleNext);

              // Remove event listener when closed
              modal.on('hidden', function () {
                nextBtn.removeEventListener('click', self.handleNext);

                // Auto-focus on the input when not disabled
                if (!self.userResponse.disabled) self.userResponse.focus();
              });
            }
          };

          // Handles swapping the visual state of the "Send" / "End chat" button.
          this.handleInputState = function (event) {
            if (event.target.value && event.target.value !== '') {
              self.submitBtn.querySelector('.button-text').textContent =
                self._object.send_text;

              // "Send" state for the button
              if (!$(self.submitBtn).hasClass('send'))
                $(self.submitBtn).addClass('send');
              self.submitBtn.dataset.state = 'continue';
              self.submitBtn.attributes['aria-label'].nodeValue =
                self._object.send_text;
            } else {
              self.submitBtn.querySelector('.button-text').textContent =
                self._object.end_chat_text;

              // "End chat" state for the button
              $(self.submitBtn).removeClass('send');
              self.submitBtn.dataset.state = 'end';
              self.submitBtn.attributes['aria-label'].nodeValue =
                self._object.end_chat_text;
            }
          };
          // Event handlers

          if (this.userResponse) {
            this.userResponse.addEventListener('keypress', this.submit);
            this.userResponse.addEventListener(
              'input',
              this.handleCharacterCount
            );
            this.userResponse.addEventListener('input', this.handleInputState);
          }
          if (this.submitBtn)
            this.submitBtn.addEventListener('click', this.submit);

          // Initialize textarea height and scroll to bottom
          this.autoGrow();
          this.scrollToBottom();
          this.observeConversation();
          this.setButtonText(this.defaultButtonText);

          // Handle pending user message from previous submit (after re-render)
          if (this.pendingUserMessage && this.conversation) {
            // Show AI is typing status
            this.setStatus(
              this._object.ai_is_typing_text,
              'ai-status-indicator ai-status-typing',
              true
            );
            this.toggleStatusSpacing(true);
            this.conversation.classList.add('ai-chat-conversation--typing');
            this.setButtonText(this.defaultButtonText);
            this.disableInput(false);
            this.scrollToBottom();

            // After 3 seconds, reveal the AI response
            setTimeout(function () {
              document.body.classList.remove('ai-chat-pending-response');
              self.conversation.classList.remove(
                'ai-chat-conversation--typing'
              );

              // We need to adapt current flow also to the redirecting state when finished
              if (
                self._object.finished &&
                self.statusIndicator &&
                self.savedRedirectingHTML
              ) {
                self.statusIndicator.innerHTML = self.savedRedirectingHTML;
                self.statusIndicator.className = 'ai-status-indicator';
                self.statusIndicator.style.display = 'block';
                self.statusIndicator.className =
                  'ai-status-indicator ai-status-redirecting';
                self.conversation.classList.add(
                  'ai-chat-conversation--redirecting'
                );
                self.toggleStatusSpacing(true);
                self.disableInput(true);
              } else {
                self.setStatus('', 'ai-status-indicator', false);
                self.toggleStatusSpacing(false);
              }

              self.scrollToBottom();
            }, 3000);
          } else {
            // Clear the pending response class if no pending message
            document.body.classList.remove('ai-chat-pending-response');

            // Show redirecting state if finished (user went back to this view)
            if (
              this._object.finished &&
              this.statusIndicator &&
              this.savedRedirectingHTML
            ) {
              this.statusIndicator.innerHTML = this.savedRedirectingHTML;
              this.statusIndicator.className =
                'ai-status-indicator ai-status-redirecting';
              this.statusIndicator.style.display = 'block';
              this.conversation.classList.add(
                'ai-chat-conversation--redirecting'
              );
              this.toggleStatusSpacing(true);
              this.disableInput(true);
            }
          }

          // Update input height on window resize
          window.addEventListener('resize', this.updateInputHeight);

          // Enable/disable Send button based on textarea content
          this.handleInputChange = function () {
            var val = self.userResponse.value || '';
            var overLimit = val.length > self.maxCharacters;
            self.submitBtn.disabled = overLimit;
          };

          this.handleInputChange();

          this.userResponse.addEventListener('input', this.handleInputChange);

          this.userResponse.addEventListener('keypress', this.submit);
          this.submitBtn.addEventListener('click', this.submit);

          // Report buttons
          this.messageReportBtns.forEach((btn) => {
            btn.addEventListener('click', () =>
              self._openReport(btn.dataset.report, btn.dataset.content)
            );
          });
        }
      },
      destroy: function destroy() {
        try {
          if (this.errorContinueBtn) {
            this.errorContinueBtn.removeEventListener(
              'click',
              this.handleErrorContinue
            );
          }

          if (this.consentAcknowledged && this.handleChange) {
            this.consentAcknowledged.removeEventListener(
              'change',
              this.handleChange
            );
          }

          if (
            this.continueBtn &&
            this.skipBtn &&
            this.handleContinue &&
            this.handleSkip
          ) {
            this.continueBtn.removeEventListener('click', this.handleContinue);
            this.continueBtn.removeEventListener(
              'keypress',
              this.handleContinue
            );

            this.skipBtn.removeEventListener('click', this.handleSkip);
            this.skipBtn.removeEventListener('keypress', this.handleSkip);
          }

          if (this.userResponse && this.submitBtn && this.submit) {
            this.userResponse.removeEventListener('keypress', this.submit);
            this.userResponse.removeEventListener(
              'input',
              this.handleCharacterCount
            );
            if (this.handleInputChange)
              this.userResponse.removeEventListener(
                'input',
                this.handleInputChange
              );
            if (this.handleInputState)
              this.userResponse.removeEventListener(
                'input',
                this.handleInputState
              );
            this.submitBtn.removeEventListener('click', this.submit);
          }
          if (this.conversationObserver) {
            this.conversationObserver.disconnect();
          }
        } catch (error) {}
      },
      _openReport: function _openReport(index, content) {
        let self = this;

        const modal = $(`#report-modal`);
        const modalEl = document.getElementById(`report-modal`);
        const modalContent = modalEl.getElementsByClassName('modal-content');
        const modalContentMessage =
          modalContent[0].getElementsByClassName('message');
        const modalContentSuccess = modalEl.getElementsByClassName(
          'modal-content-success'
        );

        if (modalContentMessage && modalContentMessage.length > 0)
          modalContentMessage[0].textContent = content;

        const reasonField = modalEl.querySelector(`fieldset[name="reason"]`);
        const nextBtn = modalEl.querySelector('button.next');

        this.handleChange = function () {
          nextBtn.removeAttribute('disabled');
        };

        this.handleNext = function (event) {
          event.preventDefault();

          const formData = new FormData();
          formData.append(`__submit__`, 1);
          formData.append(`__this__`, page_state['this_page']);
          formData.append(`__all__`, page_state['allvars'].join('|'));
          formData.append(`${self._object.id}-action`, 'report');
          formData.append(
            `${self._object.id}-reported_conversation_index`,
            index
          );

          const selectedReason = modalEl.querySelector(
            'input[name="reported_reason"]:checked'
          );
          if (selectedReason)
            formData.append(
              `${self._object.id}-reported_reason`,
              selectedReason.value
            );

          formData.append(
            `${self._object.id}-reported_other`,
            modalEl.querySelector('input[name="reported_other"]').value
          );

          // Submit to endpoint.
          let xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.crossDomain = true;

          // Local Development uses a Proxy
          let requestUrl =
            window.context_name === 'preview'
              ? `/preview/api/q${window.location.pathname}`
              : `/api/q${window.location.pathname}`;

          // Everything else expects to be given the base URL
          if (
            process.env.ENVIRONMENT !== 'development' &&
            process.env.NODE_ENV !== 'test'
          ) {
            requestUrl =
              window.context_name === 'preview'
                ? `${
                    localStorage.getItem('ivw_be')
                      ? localStorage.getItem('ivw_be')
                      : process.env.PROXY_GRYPHON_API_URL
                  }/api/q${window.location.pathname}`
                : `${process.env.PROXY_IVW_URL}/api/q${window.location.pathname}`;
          }

          xhr.addEventListener('load', () => {
            if (
              xhr.readyState === 4 &&
              (xhr.status === 200 || xhr.status === 204)
            ) {
              // show success message in modal
              if (modalContent && modalContent.length > 0)
                modalContent[0].style.display = 'none';

              if (modalContentSuccess && modalContentSuccess.length > 0)
                modalContentSuccess[0].style.display = 'block';
            } else if (xhr.status >= 400) {
              console.error(xhr.response);
            }
          });

          function formDataToUrlEncoded(formData) {
            const params = new URLSearchParams();
            for (const [key, value] of formData) {
              params.append(key, value);
            }
            return params.toString();
          }

          xhr.open('POST', requestUrl, true);

          xhr.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
          );

          const urlEncodedData = formDataToUrlEncoded(formData);
          xhr.send(urlEncodedData);
        };

        reasonField.addEventListener('change', this.handleChange);
        nextBtn.addEventListener('click', this.handleNext);

        // Reset modal state and event listeners when closed
        modal.on('hidden', function () {
          reasonField.removeEventListener('change', self.handleChange);
          nextBtn.removeEventListener('click', self.handleNext);
          nextBtn.disabled = true;

          const checked = modalEl.querySelectorAll(
            'input[name="reported_reason"]:checked'
          );
          checked.forEach((input) => (input.checked = false));
          const otherReason = modalEl.querySelector(
            'input[name="reported_other"]'
          );
          otherReason.value = '';

          if (modalContent && modalContent.length > 0)
            modalContent[0].style.display = 'block';

          if (modalContentSuccess && modalContentSuccess.length > 0)
            modalContentSuccess[0].style.display = 'none';

          // Auto-focus on the input when not disabled
          if (!self.userResponse.disabled) self.userResponse.focus();
        });
      },
      _setAction: function _setAction(action) {
        /**
         * Expected values (tentative):
         * - agree
         * - disagree
         * - continue
         * - end
         * - report
         */
        let self = this;

        if (action) {
          self.actionInput = document.getElementsByName(
            `${self._object.id}-action`
          );

          // Set the form field based on the action
          if (self.actionInput && self.actionInput.length > 0)
            self.actionInput[0].value = action;
        }
      },
    },
    {
      types: ['ai-chat'],
      views: ['ai-chat'],
    }
  );
  AIChat.register();
  widgets.AIChat = AIChat;
})((Gryphon.widgets = Gryphon.widgets || {}));
